import { firstValueFrom } from 'rxjs';
import { trackByIndex } from '@shared/common/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrganizationUnitDto, OrganizationUnitServiceProxy } from '@shared/service-proxies/service-proxies';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-organization-unit-filter',
  templateUrl: './organization-unit-filter.component.html',
  styleUrls: ['./organization-unit-filter.component.css']
})
export class OrganizationUnitFilterComponent implements OnInit {
    readonly trackByIndex = trackByIndex;

  items: OrganizationUnitDto[];
    @Output() changeOrg = new EventEmitter<OrganizationUnitDto[]>();
    @Input() inputOrgitems: OrganizationUnitDto[];

  // Input properties
  @Input() multiselect: boolean;
  @Input() closeOnSelect: boolean;
  @Input() placeholder: string;
  
  // Non input properties
  bindLabel: string = "displayName";
  selectedItems: OrganizationUnitDto[];
  isOpen: boolean;
  loading: boolean = false;
  showselectall: boolean = true;
  showdeselectall:boolean = false;

  constructor(private _organizationUnitServiceProxy: OrganizationUnitServiceProxy) {
  }

    async ngOnInit() {
        this.selectedItems = this.inputOrgitems;
    this.loading = true;
this.items = await firstValueFrom(this._organizationUnitServiceProxy.getOrganizationUnits(undefined).pipe(map(r => r.items)));
    this.loading = false;
    }


    ngOnChanges() {
        this.selectedItems = this.inputOrgitems;
    }

  emitSelection() {
    if(this.selectedItems.length != this.items.length){
      this.showselectall = true;
      this.showdeselectall = false;
      } else {
          this.showselectall = false;
          this.showdeselectall = true;
      }
    this.changeOrg.emit(this.selectedItems);
  }

  selectAll() {
    this.selectedItems = this.items;
    this.showselectall=false;
    this.showdeselectall = true;
    this.changeOrg.emit(this.selectedItems);
  }

  unselectAll() {
    this.selectedItems = [];
    this.showselectall=true;
    this.showdeselectall = false;
    this.changeOrg.emit(this.selectedItems);
  }


  rearrangeItems() {
  }

  checkUncheck(item) {
    item.selected = !item.selected;
  }
}
